import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-hot-toast';
import PrivacyPolicyModal from '../PrivacyPolicyModal';
import TermsOfServiceModal from '../TermsOfServiceModal';

const Footer = () => {
  const { t } = useTranslation();
  const footerCopyrightText = '© 2026 Elena Fiore';
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  // Функция для копирования текста в буфер обмена
  const copyToClipboard = async (text, type) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`${type} скопирован в буфер обмена!`);
    } catch (err) {
      console.error('Ошибка копирования: ', err);
      // Fallback для старых браузеров
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        toast.success(`${type} скопирован в буфер обмена!`);
      } catch (fallbackErr) {
        console.error('Fallback копирование не удалось: ', fallbackErr);
        toast.error('Не удалось скопировать');
      }
      document.body.removeChild(textArea);
    }
  };

  const socialLinks = [
    {
      name: 'Pinterest',
      translationKey: 'footer.social_networks.pinterest',
      href: 'https://pin.it/56rkY2rOf',
      icon: (
        <img 
          src="/images/logo/pinterest.svg" 
          alt="Pinterest" 
          className="w-5 h-5"
        />
      )
    },
    {
      name: 'VK',
      translationKey: 'footer.social_networks.vk',
      href: 'https://vk.com/elenafioresomebana',
      icon: (
        <img 
          src="/images/logo/vk.svg" 
          alt="VK" 
          className="w-5 h-5"
        />
      )
    }
  ];

  return (
    <footer style={{ backgroundColor: '#EC8C8E' }} className="text-white rounded-t-2xl overflow-hidden">
      <div className="container-custom">
        <div className="pt-6 pb-4 md:py-10">
          <div className="md:hidden mx-auto w-full max-w-[22rem] flex flex-col items-center gap-3">
            <Link to="/" className="flex items-center">
              <img
                src="/images/logo/logo.svg"
                alt="Elena Fiore Couture"
                className="h-10 w-auto"
              />
            </Link>

            <p className="text-white/80 text-sm text-center">
              {footerCopyrightText}
            </p>
          </div>

          <div className="hidden md:grid md:grid-cols-[auto_1fr] items-center gap-4">
            <Link to="/" className="justify-self-start flex items-center">
              <img
                src="/images/logo/logo.svg"
                alt="Elena Fiore Couture"
                className="h-12 w-auto"
              />
            </Link>

            <div className="justify-self-end flex items-center gap-2">
              <button
                onClick={() => copyToClipboard('dmitrieva3333@mail.ru', 'Email')}
                className="w-10 h-10 bg-white/15 rounded-lg flex items-center justify-center hover:bg-white/25 transition-colors"
                title="Нажмите для копирования"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </button>
              <button
                onClick={() => copyToClipboard('+79193800501', 'Телефон')}
                className="w-10 h-10 bg-white/15 rounded-lg flex items-center justify-center hover:bg-white/25 transition-colors"
                title="Нажмите для копирования"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
              </button>
              {socialLinks.map((social) => (
                <a
                  key={`desktop-${social.name}`}
                  href={social.href}
                  className="w-10 h-10 bg-white/15 rounded-lg flex items-center justify-center hover:bg-white/25 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                  title={t(social.translationKey)}
                >
                  <div className="filter brightness-0 invert">
                    {social.icon}
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-0 pb-6 md:py-8">
          <div className="mx-auto w-full max-w-[22rem] md:max-w-none">
            <div className="flex flex-col md:flex-row justify-between items-center gap-2 md:gap-0">
              <p className="hidden md:block text-white/80 text-sm text-center md:text-left">
                {footerCopyrightText}
              </p>

              <div className="md:hidden w-full flex items-center justify-center gap-3">
                <button
                  onClick={() => copyToClipboard('dmitrieva3333@mail.ru', 'Email')}
                  className="w-10 h-10 bg-white/15 rounded-lg flex items-center justify-center hover:bg-white/25 transition-colors"
                  title="Нажмите для копирования"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </button>

                <button
                  onClick={() => copyToClipboard('+79193800501', 'Телефон')}
                  className="w-10 h-10 bg-white/15 rounded-lg flex items-center justify-center hover:bg-white/25 transition-colors"
                  title="Нажмите для копирования"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                </button>

                {socialLinks.map((social) => (
                  <a
                    key={`mobile-bottom-${social.name}`}
                    href={social.href}
                    className="w-10 h-10 bg-white/15 rounded-lg flex items-center justify-center hover:bg-white/25 transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                    title={t(social.translationKey)}
                  >
                    <div className="filter brightness-0 invert">
                      {social.icon}
                    </div>
                  </a>
                ))}
              </div>
              
              <div className="mt-1 md:mt-0 flex flex-col items-center gap-2 md:flex-row md:gap-6">
                <button 
                  onClick={() => setShowPrivacyModal(true)}
                  className="text-white/80 hover:text-white text-sm transition-colors"
                >
                  {t('footer.privacy')}
                </button>
                <button 
                  onClick={() => setShowTermsModal(true)}
                  className="text-white/80 hover:text-white text-sm transition-colors"
                >
                  {t('footer.terms')}
                </button>
              </div>
            </div>
          </div>

          {/* Payment banner section removed */}
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <PrivacyPolicyModal 
        isOpen={showPrivacyModal} 
        onClose={() => setShowPrivacyModal(false)} 
      />

      {/* Terms of Service Modal */}
      <TermsOfServiceModal 
        isOpen={showTermsModal} 
        onClose={() => setShowTermsModal(false)} 
      />
    </footer>
  );
};

export default Footer;
